(function () {
  var SUBMIT_URL = 'https://support.miraherba.work/public/widerruf/submit';
  var ORDER_ITEMS_URL = 'https://support.miraherba.work/public/widerruf/order-items';
  var i18n = window.__wr || {};

  var selectedDisplayItems = [];

  function escHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function setStep(n) {
    document.querySelectorAll('.wr-progress-step').forEach(function(el) {
      el.classList.toggle('wr-progress-step--active', parseInt(el.getAttribute('data-step'), 10) === n);
    });
  }


  var step1 = document.getElementById('wr-step-1');
  var step2 = document.getElementById('wr-step-2');
  var step3 = document.getElementById('wr-step-3');
  var errorBox = document.getElementById('wr-error');

  var fFirst  = document.getElementById('wr-firstname');
  var fLast   = document.getElementById('wr-lastname');
  var fOrder  = document.getElementById('wr-order');
  var fEmail  = document.getElementById('wr-email');

  var spinner       = document.getElementById('wr-order-spinner');
  var loadingText   = document.getElementById('wr-order-loading-text');
  var notFound      = document.getElementById('wr-order-not-found');
  var scopeSection  = document.getElementById('wr-scope-section');
  var itemsSection  = document.getElementById('wr-items-section');
  var itemsList     = document.getElementById('wr-items-list');

  var lookedUpOrderId   = null;
  var lookedUpOrderDate = null;
  var lookedUpCurrency  = 'EUR';
  var lookedUpItems     = [];
  var orderMismatch     = false;
  var autoLoadTimer     = null;
  var fetchPromise      = null;

  function showError(msg) {
    errorBox.textContent = msg;
    errorBox.style.display = '';
    if (notFound) notFound.style.display = 'none';
    errorBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function hideError() {
    errorBox.style.display = 'none';
  }

  function validateStep1() {
    if (!fFirst.value.trim() || !fLast.value.trim() || !fOrder.value.trim() || !fEmail.value.trim()) {
      showError(i18n.err_required || 'Bitte fülle alle Pflichtfelder aus.');
      return false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fEmail.value.trim())) {
      showError(i18n.err_email || 'Bitte gib eine gültige E-Mail-Adresse ein.');
      return false;
    }
    hideError();
    return true;
  }

  function getScope() {
    var checked = document.querySelector('input[name="wr-scope"]:checked');
    return checked ? checked.value : 'all';
  }

  function formatPrice(value, currency) {
    if (value == null || value === '') return null;
    var num = parseFloat(value);
    if (isNaN(num)) return null;
    var locale = (i18n.locale || 'de') + '-' + (i18n.locale || 'de').toUpperCase();
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency || 'EUR' }).format(num);
    } catch (e) {
      return num.toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  function getSelectedItems() {
    var selected = [];
    if (!itemsList) return selected;
    itemsList.querySelectorAll('.wr-item-cb:checked').forEach(function (cb) {
      var baseLabel = decodeURIComponent(cb.value);
      var maxQty = parseInt(cb.getAttribute('data-qty') || '1', 10);
      var qty = maxQty;
      var qtyInput = document.getElementById('wr-qty-' + cb.getAttribute('data-item-id'));
      if (qtyInput) {
        qty = Math.min(Math.max(parseInt(qtyInput.value, 10) || 1, 1), maxQty);
      }
      selected.push(baseLabel + ' (×' + qty + ')');
    });
    return selected;
  }

  function getSelectedItemsDisplay() {
    var result = [];
    if (!itemsList) return result;
    itemsList.querySelectorAll('.wr-item-cb:checked').forEach(function (cb) {
      var baseLabel = decodeURIComponent(cb.value);
      var maxQty = parseInt(cb.getAttribute('data-qty') || '1', 10);
      var qty = maxQty;
      var qtyInput = document.getElementById('wr-qty-' + cb.getAttribute('data-item-id'));
      if (qtyInput) {
        qty = Math.min(Math.max(parseInt(qtyInput.value, 10) || 1, 1), maxQty);
      }
      result.push({ label: baseLabel, qty: qty });
    });
    return result;
  }

  function renderItemsReview(container, displayItems, scope) {
    var lbl = i18n.lbl_qty || 'Menge';
    if (scope === 'items' && displayItems.length) {
      container.innerHTML = displayItems.map(function(item) {
        return '<div class="wr-review-item">• ' + escHtml(item.label) + ' <span class="wr-review-qty">· ' + lbl + ': ' + item.qty + '</span></div>';
      }).join('');
    } else {
      container.innerHTML = '<div class="wr-review-item">• ' + escHtml(i18n.lbl_scope_all || 'Gesamte Bestellung') + '</div>';
    }
  }

  function clearOrderData() {
    if (itemsSection) itemsSection.style.display = 'none';
    if (scopeSection) scopeSection.style.display = 'none';
    if (itemsList) itemsList.innerHTML = '';
    if (notFound) notFound.style.display = 'none';
    if (loadingText) loadingText.style.display = 'none';
    lookedUpOrderId   = null;
    lookedUpOrderDate = null;
    lookedUpItems     = [];
    orderMismatch     = false;
    fetchPromise      = null;
  }

  function triggerAutoLoad() {
    clearTimeout(autoLoadTimer);
    clearOrderData();
    var email = fEmail.value.trim();
    var order = fOrder.value.trim();
    if (!email || !order) return;
    autoLoadTimer = setTimeout(fetchOrderItems, 500);
  }

  if (fOrder) fOrder.addEventListener('input', triggerAutoLoad);
  if (fEmail) fEmail.addEventListener('input', triggerAutoLoad);

  // ── Scope radio toggle ──────────────────────────────────────────────────────
  document.querySelectorAll('input[name="wr-scope"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (getScope() === 'items') {
        itemsSection.style.display = 'block';
      } else {
        itemsSection.style.display = 'none';
      }
    });
  });

  // ── Render items list ───────────────────────────────────────────────────────
  function renderItems(items) {
    itemsList.innerHTML = '';
    items.forEach(function (item) {
      var baseLabel = item.title + (item.variant_title ? ' – ' + item.variant_title : '');
      var card = document.createElement('div');
      card.className = 'wr-item-check';

      var lbl = document.createElement('label');
      lbl.className = 'wr-item-label';
      lbl.setAttribute('for', 'wr-item-' + item.id);

      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.className = 'wr-item-cb';
      cb.value = encodeURIComponent(baseLabel);
      cb.checked = false;
      cb.id = 'wr-item-' + item.id;
      cb.setAttribute('data-qty', String(item.quantity));
      cb.setAttribute('data-item-id', String(item.id));

      // Image
      var imgWrap = document.createElement('div');
      imgWrap.className = 'wr-item-img';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.loading = 'lazy';
        imgWrap.appendChild(img);
      } else {
        imgWrap.classList.add('wr-item-img--placeholder');
      }

      // Body
      var body = document.createElement('div');
      body.className = 'wr-item-body';

      var titleEl = document.createElement('div');
      titleEl.className = 'wr-item-title';
      titleEl.textContent = baseLabel;

      var metaEl = document.createElement('div');
      metaEl.className = 'wr-item-meta';
      var metaParts = [];
      metaParts.push((i18n.lbl_qty || 'Menge') + ': ' + item.quantity);
      var priceFormatted = formatPrice(item.price, lookedUpCurrency);
      if (priceFormatted) metaParts.push(priceFormatted);
      if (item.sku) metaParts.push('SKU: ' + item.sku);
      metaEl.textContent = metaParts.join(' · ');

      body.appendChild(titleEl);
      body.appendChild(metaEl);

      lbl.appendChild(cb);
      lbl.appendChild(imgWrap);
      lbl.appendChild(body);
      card.appendChild(lbl);

      // Qty picker — only when quantity > 1
      if (item.quantity > 1) {
        var qtyRow = document.createElement('div');
        qtyRow.className = 'wr-qty-row';
        qtyRow.style.display = 'none';

        var qtyLbl = document.createElement('label');
        qtyLbl.className = 'wr-qty-label';
        qtyLbl.setAttribute('for', 'wr-qty-' + item.id);
        qtyLbl.textContent = (i18n.lbl_qty || 'Menge') + ': ';

        var qtyInput = document.createElement('input');
        qtyInput.type = 'number';
        qtyInput.className = 'wr-item-qty-input';
        qtyInput.id = 'wr-qty-' + item.id;
        qtyInput.min = '1';
        qtyInput.max = String(item.quantity);
        qtyInput.value = String(item.quantity);

        qtyLbl.appendChild(qtyInput);
        qtyRow.appendChild(qtyLbl);
        card.appendChild(qtyRow);

        cb.addEventListener('change', function () {
          qtyRow.style.display = cb.checked ? 'flex' : 'none';
        });
      }

      itemsList.appendChild(card);
    });
  }

  // ── Order lookup ────────────────────────────────────────────────────────────
  function fetchOrderItems() {
    var email = fEmail.value.trim();
    var order = fOrder.value.trim();
    if (!email || !order) return Promise.resolve();

    if (fetchPromise) return fetchPromise;

    hideError();
    spinner.style.display = 'inline-block';
    loadingText.style.display = 'inline';
    notFound.style.display = 'none';
    scopeSection.style.display = 'none';
    itemsSection.style.display = 'none';
    orderMismatch = false;

    var url = ORDER_ITEMS_URL + '?email=' + encodeURIComponent(email) + '&order_number=' + encodeURIComponent(order);
    fetchPromise = fetch(url).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || !data.found || !data.items || !data.items.length) {
          notFound.style.display = 'inline';
          if (res.ok && data.found === false) orderMismatch = true;
        } else {
          lookedUpOrderId   = data.order_id || null;
          lookedUpOrderDate = data.order_date || null;
          lookedUpCurrency  = data.currency || 'EUR';
          lookedUpItems     = data.items;

          renderItems(data.items);
          scopeSection.style.display = 'block';
          // Items panel only visible if "items" scope is selected (default: all)
          itemsSection.style.display = getScope() === 'items' ? 'block' : 'none';
        }
      });
    }).catch(function () {
      notFound.style.display = 'inline';
    }).then(function () {
      spinner.style.display = 'none';
      loadingText.style.display = 'none';
      fetchPromise = null;
    });

    return fetchPromise;
  }

  // ── Step 1 → Step 2 ────────────────────────────────────────────────────────
  document.getElementById('wr-btn-next').addEventListener('click', async function () {
    if (!validateStep1()) return;

    // Cancel pending debounce, ensure lookup is complete
    if (autoLoadTimer) { clearTimeout(autoLoadTimer); autoLoadTimer = null; }

    if (fetchPromise) {
      await fetchPromise;
    } else if (!lookedUpOrderId && !orderMismatch && notFound.style.display === 'none') {
      await fetchOrderItems();
    }

    if (orderMismatch) {
      showError(i18n.err_order_mismatch || 'Bitte überprüfe E-Mail-Adresse und Bestellnummer.');
      return;
    }

    var scope = getScope();
    if (scope === 'items') {
      var anyChecked = itemsList.querySelectorAll('.wr-item-cb:checked').length > 0;
      if (!anyChecked) {
        showError(i18n.err_no_items || 'Bitte wähle mindestens einen Artikel aus.');
        return;
      }
    }

    var fullName = fFirst.value.trim() + ' ' + fLast.value.trim();
    var order    = fOrder.value.trim();
    var email    = fEmail.value.trim();
    var locale   = (i18n.locale || 'de').slice(0, 2);
    var localeTag = locale + '-' + locale.toUpperCase();

    document.getElementById('wr-c-name').textContent = fullName;
    document.getElementById('wr-c-order').textContent = order;
    document.getElementById('wr-c-email').textContent = email;
    document.getElementById('wr-c-email2').textContent = email;

    var cOrderDateLabel = document.getElementById('wr-c-order-date-label');
    var cOrderDate      = document.getElementById('wr-c-order-date');
    if (lookedUpOrderDate) {
      try {
        var dt = new Date(lookedUpOrderDate);
        cOrderDate.textContent = dt.toLocaleDateString(localeTag, { dateStyle: 'long' });
        cOrderDate.style.display = '';
        cOrderDateLabel.style.display = '';
      } catch (e) {
        cOrderDate.style.display = 'none';
        cOrderDateLabel.style.display = 'none';
      }
    } else {
      cOrderDate.style.display = 'none';
      cOrderDateLabel.style.display = 'none';
    }

    var cItemsRow = document.getElementById('wr-c-items-row');
    selectedDisplayItems = scope === 'items' ? getSelectedItemsDisplay() : [];
    renderItemsReview(cItemsRow, selectedDisplayItems, scope);

    hideError();
    step1.style.display = 'none';
    step2.style.display = 'block';
    setStep(2);
    step2.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // ── Step 2 → Step 1 ────────────────────────────────────────────────────────
  document.getElementById('wr-btn-back').addEventListener('click', function () {
    step2.style.display = 'none';
    step1.style.display = 'block';
  });

  // ── Submit ──────────────────────────────────────────────────────────────────
  document.getElementById('wr-btn-confirm').addEventListener('click', async function () {
    var btn = this;
    btn.disabled = true;

    var name     = fFirst.value.trim() + ' ' + fLast.value.trim();
    var order    = fOrder.value.trim();
    var email    = fEmail.value.trim();
    var locale   = (i18n.locale || 'de').slice(0, 2);
    var scope    = getScope();
    var selected = scope === 'items' ? getSelectedItems() : [];

    var payload = {
      name: name,
      order_number: order,
      email: email,
      language: locale,
      scope: scope,
    };
    if (selected.length) payload.selected_items = selected;
    if (lookedUpOrderId) payload.order_id = lookedUpOrderId;

    try {
      var res = await fetch(SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      var data = await res.json();
      if (!res.ok) {
        step2.style.display = 'none';
        step1.style.display = 'block';
        showError(data.error || 'Fehler. Bitte erneut versuchen.');
        btn.disabled = false;
        return;
      }

      var localeTag = locale + '-' + locale.toUpperCase();

      // Receipt
      var sId = document.getElementById('wr-s-id');
      if (sId) sId.textContent = 'WR-' + String(data.id).padStart(6, '0');

      var tsEl = document.getElementById('wr-s-ts');
      if (tsEl && data.declaredAt) {
        var dt = new Date(data.declaredAt.replace(' ', 'T') + 'Z');
        tsEl.textContent = dt.toLocaleString(localeTag, { dateStyle: 'long', timeStyle: 'short' });
      }

      document.getElementById('wr-s-email').textContent = email;
      document.getElementById('wr-s-email2').textContent = email;
      document.getElementById('wr-s-name').textContent = name;
      document.getElementById('wr-s-order').textContent = order;

      var sOrderDate   = document.getElementById('wr-s-order-date');
      var sOrderDateDt = document.getElementById('wr-s-order-date-dt');
      if (lookedUpOrderDate) {
        try {
          var odt = new Date(lookedUpOrderDate);
          sOrderDate.textContent = odt.toLocaleDateString(localeTag, { dateStyle: 'long' });
          sOrderDate.style.display = '';
          sOrderDateDt.style.display = '';
        } catch (e) { /* ignore */ }
      }

      var sItems = document.getElementById('wr-s-items');
      renderItemsReview(sItems, selectedDisplayItems, scope);

      step2.style.display = 'none';
      step3.style.display = 'block';
      setStep(3);
      step3.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (e) {
      showError('Verbindungsfehler. Bitte später erneut versuchen.');
      btn.disabled = false;
    }
  });

  // Pre-fill from ?order= URL parameter and auto-load if email is also set
  var orderParam = new URLSearchParams(window.location.search).get('order');
  if (orderParam && fOrder) {
    fOrder.value = orderParam;
    triggerAutoLoad();
  }
})();
